import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { IconProps } from '@models/icons';
import { JSX } from 'react';

interface Props {
    icon: (props: IconProps) => JSX.Element;
    title: string;
    content?: string;
    onClick?: () => void;
}

function CsItem({
  icon: Icon, title, content, onClick,
}:Props) {
  return (
        <Container onClick={onClick}>
            <Row fullWidth justify='space-between'>
                <Row spacing={8}>
                    <Icon size={16} color={colors.gray7} />
                    <Text size='lg' fontWeight='medium'>{title}</Text>
                </Row>
                <ArrowLineRight size={18}/>
            </Row>
            {content && (
                <Text color={colors.gray7} size='s' css={css`
                white-space: pre-wrap;
            `}>{content}</Text>
            )}
        </Container>
  );
}

const Container = styled.div`
    background-color: ${colors.gray1};
    padding: 16px;
    border-radius: 4px;
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
`;

export default CsItem;
